// extracted by mini-css-extract-plugin
export default {"root":"SnakeLayoutRow-module-root-WjUAs","verticalColumn":"SnakeLayoutRow-module-verticalColumn-xrHvJ"};